(() => {
  const relatedSelector = '.main-product__related';

  // Refresh also runs for card layout/content changes. Avoid rewriting outputs
  // that are already correct while keeping every existing refresh trigger.
  const setAttributeIfChanged = (node, name, value) => {
    if (node.getAttribute(name) !== value) node.setAttribute(name, value);
  };

  const updateControls = (section) => {
    const track = section.querySelector('[data-yx-related-track]');
    const prev = section.querySelector('[data-yx-related-prev]');
    const next = section.querySelector('[data-yx-related-next]');
    if (!track || !prev || !next || prev.hidden || next.hidden) return;
    const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    const canScroll = maxScroll > 2;
    const prevDisabled = !canScroll || track.scrollLeft <= 2;
    const nextDisabled = !canScroll || track.scrollLeft >= maxScroll - 2;
    if (prev.disabled !== prevDisabled) prev.disabled = prevDisabled;
    if (next.disabled !== nextDisabled) next.disabled = nextDisabled;
  };

  const setupSection = (section) => {
    const track = section.querySelector('[data-yx-related-track]');
    const prev = section.querySelector('[data-yx-related-prev]');
    const next = section.querySelector('[data-yx-related-next]');
    if (!track || !prev || !next) return;
    [prev, next].forEach((button) => {
      if (button.disabled) button.disabled = false;
      if (button.hidden) button.hidden = false;
      if (button.getAttribute('tabindex') !== '0') button.tabIndex = 0;
      if (button.hasAttribute('aria-hidden')) button.removeAttribute('aria-hidden');
    });
    track.querySelectorAll('[data-yx-related-empty]').forEach((empty) => {
      setAttributeIfChanged(empty, 'role', 'status');
      setAttributeIfChanged(empty, 'aria-live', 'polite');
    });
    const items = Array.from(track.querySelectorAll(':scope > li:not([data-yx-related-empty])'));
    if (items.length < 2) {
      [prev, next].forEach((button) => {
        if (!button.disabled) button.disabled = true;
        if (button.hidden !== true) button.hidden = true;
        if (button.getAttribute('tabindex') !== '-1') button.tabIndex = -1;
        setAttributeIfChanged(button, 'aria-hidden', 'true');
      });
      return;
    }
    requestAnimationFrame(() => updateControls(section));
    if (track.dataset.yxRelatedControlsReady !== 'true') {
      track.dataset.yxRelatedControlsReady = 'true';
      track.addEventListener('scroll', () => updateControls(section), { passive: true });
    }
  };

  const init = (root) => {
    if (!root || root.dataset.yxRecommendationRailsReady === 'true') return;
    root.dataset.yxRecommendationRailsReady = 'true';

    const refresh = () => root.querySelectorAll(relatedSelector).forEach(setupSection);
    const recommendationsRoot = root.querySelector('product-recommendations');
    const preserveFallback = () => {
      if (!recommendationsRoot?.classList.contains('hidden')) return;
      if (recommendationsRoot.dataset.yxRelatedSource !== 'fallback-error') recommendationsRoot.dataset.yxRelatedSource = 'fallback-error';
      if (recommendationsRoot.dataset.source !== 'fallback-error') recommendationsRoot.dataset.source = 'fallback-error';
      const fallback = recommendationsRoot.querySelector('.main-product__recommendations-inner');
      if (!fallback) return;
      if (fallback.dataset.yxRelatedSource !== 'fallback-error') fallback.dataset.yxRelatedSource = 'fallback-error';
      if (fallback.dataset.source !== 'fallback-error') fallback.dataset.source = 'fallback-error';
    };

    refresh();
    root.addEventListener('yx:pdp-related-updated', refresh);
    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-yx-related-prev], [data-yx-related-next]');
      if (!button || !root.contains(button) || button.disabled) return;
      const section = button.closest(relatedSelector);
      const track = section?.querySelector('[data-yx-related-track]');
      if (!track) return;
      const firstCard = track.querySelector(':scope > li:not([data-yx-related-empty])');
      const cardWidth = firstCard ? firstCard.getBoundingClientRect().width : track.clientWidth;
      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      const direction = button.hasAttribute('data-yx-related-prev') ? -1 : 1;
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      const target = Math.min(maxScroll, Math.max(0, track.scrollLeft + direction * (cardWidth + gap)));
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      track.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
      window.setTimeout(() => updateControls(section), reduceMotion ? 0 : 360);
    });
    root.addEventListener('click', (event) => {
      const cardMedia = event.target.closest(`${relatedSelector} .yx-product-card__media`);
      if (cardMedia && !event.target.closest('button, a, [data-yx-product-swatch]')) {
        const mediaLink = cardMedia.closest('.yx-product-card')?.querySelector('.yx-product-card__title a');
        if (mediaLink?.getAttribute('href')) window.location.href = mediaLink.getAttribute('href');
      }
    });
    window.addEventListener('resize', () => root.querySelectorAll(relatedSelector).forEach(updateControls));
    if (recommendationsRoot) {
      new MutationObserver(() => {
        preserveFallback();
        refresh();
      }).observe(recommendationsRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'data-error'],
      });
      preserveFallback();
    }
  };

  window.YurinoxPdpRecommendationRails = { init };
  document.querySelectorAll('[data-yx-product-root], [data-yx-pdp-recommendations-root]').forEach(init);
})();
